// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import markerPin06Icon from "@/assets/icons/marker-pin-06.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MarkerPin06IconProps = Omit<IconProps, "name">;

export function MarkerPin06Icon(props: MarkerPin06IconProps): React.ReactNode {
  return <Icon name={markerPin06Icon} {...props} />;
}
